import useBetaFeatures from "hooks/useBetaFeatures";

/**
 * The whole guided walkthrough is behind a beta flag while its shape is still
 * being decided — step counts, whether a short read-only tour should be the
 * default, and how much of the interactive form survives.
 *
 * Beta features are opt-in: an org without the flag gets no walkthrough at
 * all, which is what makes this safe to leave in main while that is settled.
 *
 * Every entry point asks this rather than checking the flag itself, so turning
 * the feature on or off is one edit and cannot be half-applied — the runner,
 * the first-login trigger and the help-menu item must agree, or a user is
 * offered something that does not open.
 */
export const GUIDED_WALKTHROUGH_BETA_FEATURE = "Guided Walkthrough";

export function useWalkthroughEnabled(): boolean {
  const { hasFeature } = useBetaFeatures();
  return hasFeature(GUIDED_WALKTHROUGH_BETA_FEATURE);
}
